import { render, staticRenderFns } from "./MallSelect.vue?vue&type=template&id=3f8f7e0c&"
import script from "./MallSelect.vue?vue&type=script&lang=ts&"
export * from "./MallSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports